const todoCountName = 'todoCount'
const toReadCountName = 'toReadCount'
const toMyCountName = 'toMyCount'
const todoCountBussinessName = 'todoCountBussiness'

const messageInfo = {
    namespaced: true,
    state: {
        todoCount: 0,
        toReadCount: 0,
        toMyCount: 0,
        todoCountBussiness:0
    },
    getters: {
        GET_TODOCOUNT(state) {
            return state.todoCount || sessionStorage.getItem(todoCountName)
        },
        GET_TOREADCOUNT(state) {
            return state.toReadCount || sessionStorage.getItem(toReadCountName)
        },
        GET_TOMYCOUNT(state) {
            return state.toMyCount || sessionStorage.getItem(toMyCountName)
        },
        GET_TODOCOUNTBUSSINESS(state) {
            return state.todoCountBussiness || sessionStorage.getItem(todoCountBussinessName)
        },
    },
    mutations: {
        SET_TODOCOUNT(state, todoCount) {
            state.todoCount = todoCount
            sessionStorage.setItem(todoCountName, todoCount)
        },
        SET_TODOCOUNTBUSSINESS(state, todoCountBussiness) {
            state.todoCountBussiness = todoCountBussiness
            sessionStorage.setItem(todoCountBussinessName, todoCountBussiness)
        },
        SET_TOREADCOUNT(state, toReadCount) {
            state.toReadCount = toReadCount
            sessionStorage.setItem(toReadCountName, toReadCount)
        },
        SET_TOMYCOUNT(state, toMyCount) {
            state.toMyCount = toMyCount
            sessionStorage.setItem(toMyCountName, toMyCount)
        },
        REMOVE_MESSAGE_COUNT(state) {
            state.todoCount = 0
            state.toReadCount = 0
            state.todoCountBussiness = 0
            sessionStorage.removeItem(todoCountName)
            sessionStorage.removeItem(toReadCountName)
            sessionStorage.removeItem(todoCountBussinessName)
        }
    }
}

export default messageInfo